// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J99R","index":"styles_index__3UQte"};